<div matSnackBarLabel>
  @switch (error.code) {
    @case (codes.AllUsersExist) {
      Tous les utilisateurs importés existent déjà.
    }
    @case (codes.InvalidFile) {
      Le fichier envoyé n'est pas valide.
    }
    @case (codes.EmptyUserList) {
      Aucun utilisateur détecté durant l'import.
    }
    @case (codes.SubscriptionLimitExceeded) {
      Vous avez dépassé le nombre d'utilisateurs possibles.
    }
    @default {
      Désolé, une erreur inatendue est survenue.
    }
  }
</div>
<div matSnackBarActions class="actions">
  <button matButton matSnackBarAction (click)="dismiss()">OK</button>
</div>
